import { Assignment } from "~/classes/models/assignments/assignment.model";
import { Classroom } from "~/classes/models/classrooms/classroom.model";
import { Student } from "~/classes/models/students/student.model";

export const useCreateDocumentParams = ({
  userId,
  profileId,
  classroom,
  assignment,
  student,
  checklist,
  checklists,
  documentSubmissionType,
  attachChecklist = true,
  enableStudentThesaurus = false,
  enableStudentReview = false,
}: {
  userId: string;
  profileId?: string;
  classroom?: Classroom;
  assignment?: Assignment;
  student?: Student;
  checklist?: Checklist;
  checklists: Checklists;
  documentSubmissionType: DocumentSubmissionType;
  attachChecklist?: boolean;
  enableStudentThesaurus?: boolean;
  enableStudentReview?: boolean;
}) => {
  const documentParams = {} as any;

  documentParams.userId = userId;
  if (profileId) {
    documentParams.profileId = profileId;
  }
  documentParams.submittedAtTimestampMillis = Date.now();
  documentParams.enableStudentThesaurus = enableStudentThesaurus;
  documentParams.enableStudentReview = enableStudentReview;

  if (classroom) {
    var name = classroom.label;

    documentParams.classroom = {
      id: classroom.id,
      name: name,
      enableStudentReview: classroom.enableStudentReview,
      enableSubmissionBadges: classroom.enableSubmissionBadges,
      enableStudentSubmissionCreation:
        classroom.enableStudentSubmissionCreation,
      studentSubmissionCreationStudentIds:
        classroom.studentSubmissionCreationStudentIds,
      enableStudentCompare: classroom.enableStudentCompare,
      studentCompareStudentIds: classroom.studentCompareStudentIds,
      enableStudentThesaurus: classroom.enableStudentThesaurus,
      studentThesaurusStudentIds: classroom.studentThesaurusStudentIds,
    };

    if (classroom.userId) {
      documentParams.userId = classroom.userId;
    }
  }

  if (assignment) {
    documentParams.assignment = {
      id: assignment.id,
      name: assignment.name,
      openTimestamp: assignment.openTimestamp,
      dueTimestamp: assignment.dueTimestamp,
      assignmentCloseTimestamp: assignment.closeTimestamp,
      isVisibleToStudents: assignment.isVisibleToStudents,
      allowKWOSubmission: assignment.allowKWOSubmission,
      allowRoughDraftSubmission: assignment.allowRoughDraftSubmission,
      requiredKWOSubmission: assignment.requireKWOSubmission,
      requireRoughDraftSubmission: assignment.requireRoughDraftSubmission,
      requireRoughDraftChecklist: assignment.requireRoughDraftChecklist,
      roughDraftSubmissionFormats: assignment.roughDraftSubmissionFormats,
      allowFinalDraftSubmission: assignment.allowFinalDraftSubmission,
      allowFinalDraftGradedState: assignment.allowFinalDraftGradedState,
      isAutoReturnEnabled: assignment.isAutoReturnEnabled,
      type: assignment.type,
      levelId: assignment.levelId,
      lessonId: assignment.lessonId,
    };

    if (assignment.checklistId) {
      const checklistPath =
        checklists?.find((checklist) => checklist.id == assignment.checklistId)
          ?.path ?? "/checklists";

      if (checklistPath) {
        documentParams.checklist = {
          id: assignment.checklistId,
          path: checklistPath,
        };
      }
    }
  }

  if (checklist) {
    documentParams.checklist = {
      id: checklist.id,
      path: checklist.path,
    };
  }

  if (student) {
    documentParams.student = {
      id: student.id,
      name: student.name,
    };

    // documentParams.userId = student.userId;

    // Eventually here we can check if the assignmenth as studentChecklistOverrides.
    var studentId = student.id;

    if (
      assignment?.studentChecklistOverrides != undefined &&
      assignment.studentChecklistOverrides.length > 0 &&
      studentId != undefined
    ) {
      const override = assignment.studentChecklistOverrides.find((override) =>
        override.studentIds.includes(studentId!)
      );

      if (override) {
        documentParams.checklist = {
          id: override.checklistId,
          path: override.checklistPath,
        };
      }
    }
  }

  if (attachChecklist != true) {
    documentParams.checklist = undefined;
  }

  documentParams.allowFinalDraftGradedState =
    assignment?.allowFinalDraftGradedState != undefined
      ? assignment?.allowFinalDraftGradedState
      : classroom?.allowFinalDraftGradedState;

  documentParams.documentSubmissionType = documentSubmissionType;

  return documentParams;
};
